var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrozen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "List",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Article-cr\\xE9ation-Gel\\xE9",
    transform: "translate(-1196.000000, -23.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "app-bar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1060.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "156 19 151.83 19 155.07 15.76 153.66 14.34 149 19 147 19 147 17 151.66 12.34 150.24 10.93 147 14.17 147 10 145 10 145 14.17 141.76 10.93 140.34 12.34 145 17 145 19 143 19 138.34 14.34 136.93 15.76 140.17 19 136 19 136 21 140.17 21 136.93 24.24 138.34 25.66 143 21 145 21 145 23 140.34 27.66 141.76 29.07 145 25.83 145 30 147 30 147 25.83 150.24 29.07 151.66 27.66 147 23 147 21 149 21 153.66 25.66 155.07 24.24 151.83 21 156 21"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrozen);
export default __webpack_public_path__ + "static/media/frozen.97016cc4.svg";
export { ForwardRef as ReactComponent };